import * as React from 'react'
import ListCell from '@doordash/component-list-cell'
import { OnboardingComponentProps } from '.'

export const ListCellComponent: React.FC<OnboardingComponentProps> = ({
  label,
  ...props
}) => {
  return <ListCell title={label} {...props} />
}
